export const ticketDetailsLocales = {
  components: "Components",
  searchComponents: "Search by component name",
  sprints: "Sprints",
  searchSprints: "Search by sprint name",
  releases: "Releases",
  epics: "Epics",
  projectName: "Project name",
  teamName: "Team name",
  minimizeTicket: "Minimize ticket",
  minimizeTask: "Minimize task",
  deleteFromTray: "Delete from tray",
  addToFavorites: "Add to favorites",
  unFavorite: "Unfavorite",
  close: "Close",
  copyLink: "Copy link",
  copied: "Copied!",
  copyId: "Copy ID",
  newTab: "New tab",
  duplicate: "Duplicate",
  archive: "Archive",
  updating: "Updating...",
  moveToPreviousTicket: "Move to previous ticket",
  moveToNextTicket: "Move to next ticket",
  ticketId: "Ticket ID",
  clickToRename: "Click to rename",
  trackTime: "Track time",
  timeOnThisTask: "Time on this task",
  hour: "h",
  minute: "m",
  activity: "Activity",
  initiators: "Initiators",
  initiatorSearchPlaceholder: "Search by member's name or role",
  activityType: "Activity type",
  leaveCommentPlaceholder: "Leave comment",
  deleteComment: "Delete comment",
  reply: "Reply",
  threadsBy: "Thread by",
  replyCount: "{count} reply",
  reaction_added_note: "Your reaction has been successfully added.",
  reaction_removed_note: "Your reaction has been successfully removed.",
  update_reply: "comment has been successfully changed.",
  remove_comment_note: "Your comment has been successfully removed.",
  noActivityYet: "No activity yet",
  activityWillAppearHere:
    "Activity will appear here once changes are made to this ticket.",
  initiator: "Initiator: ",
  new: "New",
  effortsEstimated: "Efforts Estimated: ",
  enterTime: "Enter time",
  timeTrackerInputPlaceholder: "Enter time (ex: 3h 20m) or start timer",
  startTimer: "Start timer",
  assigneeHistory: "Assignee History",
  totalEffortsEstimated: "Total Efforts Estimated: ",
  effortsActual: "Efforts Actual: ",
  replies: "Replies",
  showMore: "Show more",
  hide: "Hide",
  searchPlaceholder: "Search",
  timeEntries: "Time entries",
  now: "Now",
  deleteEntry: "Delete entry",
  descriptionPlaceholder: "Enter ticket description",
  ticketDescription: "Ticket description",
  save: "Save",
  cancel: "Cancel",
  upload: "Upload",
  aiTextWriting: "AI text writing",
  textTemplate: "Text template",
  newTemplate: "New template",
  saveTemplate: "Save template",
  discard: "Discard",
  relations: "Relations",
  relationType: "Relation type",
  ticketName: "Ticket name",
  searchByTicketName: "Search by ticket name",
  noTicketsFound: "No tickets found",
  unlink: "Unlink",
  unlinkTicket: "Unlink ticket",
  unlinkTicketConfirmation: "Are you sure that you want to unlink ticket?",
};
